import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperValidAnwserQuestions } from '../helpers/helperValidAnwserQuestions';
import { FormGroup } from '@angular/forms';
import { Surveys } from 'src/Models/Surveys';

@Injectable({
    providedIn: 'root'
})
export class QueryParamsUtils {
    isPreview: boolean
    isIframeMode: boolean;
    id_survey_audience: string
    key_attendence: string;
    identificationParam: string;
    id_survey: string
    nameParam: string;
    tagsParam: string;
    pkeyParam: string;
    propParam: string;
    timeout: string;

    constructor(private actRoute: ActivatedRoute, private router: Router) {
        this.id_survey_audience = this.actRoute.snapshot.queryParamMap.get('aud');
        this.key_attendence = this.actRoute.snapshot.queryParamMap.get('ka');
        this.id_survey = this.actRoute.snapshot.queryParamMap.get('sur');
        this.nameParam = this.actRoute.snapshot.queryParamMap.get('n');
        this.pkeyParam = this.actRoute.snapshot.queryParamMap.get('k');
        this.tagsParam = this.actRoute.snapshot.queryParamMap.get('t');
        this.identificationParam = this.actRoute.snapshot.queryParamMap.get('i');
        this.propParam = this.actRoute.snapshot.queryParamMap.get('prop');
        this.timeout = this.actRoute.snapshot.queryParamMap.get('timeout');
        this.isPreview = this.verifyPreview();
        this.isIframeMode = this.verifyIframeMode();
    }

    verifyPreview() {
        const paramPreview = this.actRoute.snapshot.queryParamMap.get('preview')
        return paramPreview != null && paramPreview == 'true';
    }

    verifyIframeMode() {
        const paramPreview = this.actRoute.snapshot.queryParamMap.get('iframeMode')
        return paramPreview != null && paramPreview == 'true';
    }

    verifyValueFirstQuestion(form, question, callbackNextStep: (index) => void) {
        const valueAnswer = this.actRoute.snapshot.queryParamMap.get('fq');
        if (valueAnswer != null && this.id_survey_audience != undefined) {
            if (HelperValidAnwserQuestions.validQuestionAnwser(form, question, valueAnswer))
                callbackNextStep(0);
            else
                this.router.navigate(['survey-bugs'])
        }
    }

    verifyDefaultValues(form: FormGroup, survey: Surveys) {
        if (this.nameParam != null) form.get('name').setValue(this.nameParam);
        if (this.identificationParam != null) this.setIdentification(form);
        else if (this.pkeyParam != null) form.get('participant_key').setValue(this.pkeyParam);
        if (this.key_attendence != null) form.get('key_attendance').setValue(this.key_attendence);
        if (this.tagsParam != null && this.tagsParam.trim() !== '') {
            const tags = JSON.stringify({ "Tags": this.tagsParam.split(';') });
            form.get('tags').setValue(tags);
        }
        this.getPropertiesURL(form, survey);
        form.get('route_response').setValue(this.router.url);
    }

    setIdentification(form: FormGroup) {
        form.get('participant_key').setValue(this.identificationParam);
        form.get('name_key').setValue('identification');
    }

    getPropertiesURL(form: FormGroup, survey: Surveys) {
        if (this.propParam != null && survey.propertiesAudience !== null && survey.propertiesAudience.length > 0) {
            let propertiesResponse = form.get('properties').value
            let propertiesParameters = []

            this.propParam.split(';').forEach(propertie => {
                try {
                    let propertyInternalName = propertie.split(':')[0]
                    const propertieOBJ = survey.propertiesAudience.filter(x => x.internal_name == propertyInternalName)
                    if (propertieOBJ.length > 0 && propertie.split(':')[1] !== '' && propertieOBJ[0].fk_type_property === 1) {
                        propertiesParameters.push({ id_property: propertieOBJ[0].id_property, value: propertie.split(':')[1] })
                    } else {
                        this.router.navigate(['survey-bugs'])
                    }
                } catch (ex) {
                    this.router.navigate(['survey-bugs'])
                }
            });

            if (propertiesResponse === null) {
                let propertiesPut = []
                survey.propertiesAudience.forEach(element => {
                    let getPropertieConfig = propertiesParameters.filter(x => x.id_property == element.id_property)
                    propertiesPut.push({ id_property: element.id_property, value: getPropertieConfig.length > 0 ? getPropertieConfig[0].value : null })
                });
                form.get('properties').setValue(JSON.stringify(propertiesPut))
            }
        }
    }
}